import { showErrorToast } from "components/toast/showToast";
import { useOwner } from "hooks/api"

interface Props {
  ownerId: string;
  businessId: string | undefined;
}

export const OwnershipSSN = ({ ownerId, businessId }: Props) => {

  const { owner, isLoading, isError } = useOwner(ownerId, businessId, true);

  if (isLoading) {
    return (
      <span>Loading...</span>
    )
  }

  if (isError) {
    showErrorToast('Failed to fetch owner ssn')
    return (
        <span>Error fetching owner ssn.</span>
    )
  }

  return (
    <>
      ***-**-{owner?.ssn?.last4}
    </>
  )
}
